import anime from 'animejs';
import { isTouchDevice } from '@/scripts/utils';

// eslint-disable-next-line import/prefer-default-export
export default {
  data() {
    return {
      isOver: false,
      isInTransition: false,
    };
  },
  methods: {
    toggleIsInTransition(bool) {
      this.isInTransition = bool;
    },
    overAnimation(targets, reverse = false) {
      const delta = targets.length * 1.3;

      anime({
        targets,
        translateX: reverse ? 0 : anime.stagger([-delta, delta]),
        duration: 600,
        easing: 'easeOutCubic',
      });
    },
    mEnter(ev) {
      if (!isTouchDevice()) {
        this.isOver = true;
        const targets = ev.target.getElementsByClassName('stagger-element');
        if (!this.isInTransition) {
          this.overAnimation(targets);
        }
      }
    },
    mLeave(ev) {
      if (!isTouchDevice()) {
        this.isOver = false;
        const targets = ev.target.getElementsByClassName('stagger-element');
        if (!this.isInTransition) {
          this.overAnimation(targets, true);
        }
      }
    },
  },
};
